module.exports = __webpack_public_path__ + "static/media/Partner13.bebaa8f3.webp";